// @flow
import { withRouter } from 'react-router-dom';

import Body from './Body.component';

export default (withRouter(Body): any);
